import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  KeyboardView,
  Wrapper
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import {
  togglePricingPage,
  setPaymentPage,
  setDemoPage,
  toggleDemoPage
} from "app/NativeActions";

import EnginePlans from "app/DealMachineCore/components/SelectPlans/Engines/EnginePlans";
import PaymentPage from "app/DealMachineCore/components/ConfirmPayment/PaymentPage";

class PricingPageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_frequency: "annually",
      show_payment_page: false
    };

    this.onFrequencySwitch = this.onFrequencySwitch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.pricing_page &&
      this.props.pricing_page !== prevProps.pricing_page
    ) {
      this.setState({
        selected_frequency: this.props.pricing_page.frequency
      });
    }
  }

  onFrequencySwitch(selected_frequency) {
    this.setState({
      selected_frequency
    });
  }

  render() {
    const {
      show_pricing_page,
      pricing_page,
      payment_page,
      device
    } = this.props;
    const { selected_frequency, show_payment_page } = this.state;
    if (show_pricing_page && pricing_page) {
      return show_payment_page && payment_page ? (
        <ModalContainer
          style={
            this.props.device == "desktop" && !this.props.isMobile
              ? { maxWidth: 1200, height: "95vh" }
              : { maxWidth: 1200 }
          }
        >
          <Header
            title={"Confirm Engine"}
            leftButtonIcon={"arrow-back"}
            leftButtonAction={() => {
              this.setState({
                show_payment_page: false
              });
            }}
          />
          <KeyboardView style={{ maxWidth: "100%" }}>
            <Wrapper
              style={{
                maxWidth: 900,
                padding: 20,
                margin: device == "desktop" ? "0px auto" : 0
              }}
            >
              <PaymentPage
                engine_slug={payment_page.engine_slug}
                tier={payment_page.tier}
                frequency={payment_page.frequency}
                extra_fee={payment_page.extra_fee}
                extra_fee_text={payment_page.extra_fee_text}
                onSuccess={() => {
                  this.setState({
                    show_payment_page: false
                  });
                  this.props.togglePricingPage(false);
                }}
              />
            </Wrapper>
          </KeyboardView>
        </ModalContainer>
      ) : (
        <ModalContainer
          style={
            this.props.device == "desktop" && !this.props.isMobile
              ? { maxWidth: 1200, height: "95vh" }
              : { maxWidth: 1200 }
          }
        >
          <Header
            title={pricing_page.title}
            leftButtonIcon={"arrow-back"}
            leftButtonAction={() => {
              this.setState({
                show_payment_page: false
              });
              this.props.togglePricingPage(false);
            }}
          />
          <KeyboardView style={{ maxWidth: "100%" }}>
            <EnginePlans
              onEngineSelect={engine => {
                this.props.setPaymentPage({
                  engine_slug: engine.engine,
                  tier: engine.tier,
                  frequency: engine.frequency
                });
                this.setState({
                  show_payment_page: true
                });
              }}
              onDemoPress={demo => {
                this.props.setDemoPage({
                  title: demo.title,
                  webinar_id: demo.webinar_id
                });
                this.props.toggleDemoPage(true);
              }}
              include_copy={true}
              engine_slug={pricing_page.engine_slug}
              include_annual_toggle={
                pricing_page.engine_slug == "messages" ? false : true
              }
              onFrequencySwitch={this.onFrequencySwitch}
              selected_frequency={selected_frequency}
              require_tier={pricing_page.tier || 1}
            />
          </KeyboardView>
        </ModalContainer>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, native, billing, settings }) => {
  const { token, user } = auth;
  const { device, isMobile, platform } = native;
  const { colors } = settings;
  const { pricing_page, show_pricing_page, payment_page } = billing;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    colors,
    pricing_page,
    payment_page,
    show_pricing_page
  };
};

export default connect(mapStateToProps, {
  togglePricingPage,
  setPaymentPage,
  setDemoPage,
  toggleDemoPage
})(PricingPageModal);
